import React from 'react';

export default function GuidedBridgeEligibilityFrame() {
  const screenerUrl = `${process.env.PUBLIC_URL || ''}/glp1-bridge-eligibility_v23.html`;

  return (
    <section className="glp1-guided-screener" aria-label="Guided Eligibility Screener">
      <iframe
        className="glp1-guided-screener-frame"
        src={screenerUrl}
        title="Medicare GLP-1 Bridge Eligibility Screener"
      />
    </section>
  );
}
